import Model from '@/models/Model'

export default class HrPreviredIps extends Model {
    resource() {
        return 'hr_previred_ips'
    }
}